module.exports = __webpack_public_path__ + "static/img/solve4.5ba777a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solve4.png
// module id = RNE+
// module chunks = 0